import React, { Component } from 'react';
import './RSIConfig.css';
import i18next from 'i18next';

export default class RSIConfig extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
    }
  }

  changePeriod = (e: any) => {
    if (this.props.onChange) {
      this.props.onChange({ p: e.target.value });
    }
  }

  render() {
    return (
      <div className="RSIConfig">
        <div className='RSIConfig-Period'>
          <div className='RSIConfig-Period-Label'>{i18next.t("Chart.TA.Period", "")}</div>
          <div className='RSIConfig-Period-Value'><input value={this.props.config.p || ''} onChange={this.changePeriod}></input></div>
        </div>
      </div>
    );
  }
}
